import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Star } from "lucide-react";
import AdminShell from "@/components/admin/AdminShell";
import { JournalPost, formatDate, listAllPosts } from "@/lib/journalApi";

const JournalList = () => {
  const [posts, setPosts] = useState<JournalPost[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listAllPosts().then(setPosts).catch((e) => setError(e.message));
  }, []);

  return (
    <AdminShell
      title="Journal"
      actions={
        <div>
          <Link to="/admin/journal/new" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-inter">
            <Plus className="w-4 h-4" /> New article
          </Link>
        </div>
      }
    >
      {error && <p className="text-red-300 text-sm mb-4">{error}</p>}
      {!posts && !error && <p className="text-white/50 text-sm">Loading…</p>}
      <div className="space-y-3">
        {posts?.map((p) => (
          <Link key={p.id} to={`/admin/journal/${p.id}`} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-4 hover:border-primary/40 transition-colors">
            {p.cover_image_url ? (
              <img src={p.cover_image_url} alt="" className="w-16 h-16 rounded-lg object-cover shrink-0" />
            ) : (
              <div className="w-16 h-16 rounded-lg bg-white/5 shrink-0" />
            )}
            <div className="min-w-0 flex-1">
              <p className="font-playfair text-lg leading-snug truncate">{p.title}</p>
              <p className="text-xs text-white/45 font-inter mt-1">
                {p.category} · {p.status === "published" ? `Published ${formatDate(p.published_at)}` : "Draft"}
              </p>
            </div>
            {p.featured && <Star className="w-4 h-4 text-primary shrink-0" fill="currentColor" />}
            <span className={`text-[11px] uppercase tracking-widest rounded-full px-3 py-1 border shrink-0 ${p.status === "published" ? "border-primary/40 text-primary" : "border-white/20 text-white/50"}`}>
              {p.status === "published" ? "Live" : "Draft"}
            </span>
          </Link>
        ))}
      </div>
    </AdminShell>
  );
};

export default JournalList;
